import CommonMapper from '@/modules/core/mappers/CommonMapper'
import type Insurance from '@/modules/common/common/models/APP/Insurance'
import type { UserRoleEnum } from '@/modules/core/models/enums'
import type PetQuotation from '../../models/MID/PetQuotation'
import { PetsSaveQuotationRequest } from '../../models/MID/requests/PetsSaveQuotationRequest'

export default class SavePetsQuotationMapper {
  static toRequest(
    quotationId: string,
    startDate: Date,
    billingCycle: string,
    product: Insurance,
    pets: PetQuotation[],
    role: UserRoleEnum | undefined = undefined
  ): PetsSaveQuotationRequest {
    return new PetsSaveQuotationRequest({
      quotationId,
      hiring: {
        ...product,
        billingCycle: CommonMapper.toDXPProductPrice(billingCycle),
        insuranceStartDate: CommonMapper.toMiddlewareDate(startDate),
        pets,
        role
      }
    })
  }
}
